'use client';

import React, { useState } from 'react';
import clsx from 'clsx';
import { asText, isFilled } from '@prismicio/helpers';
import { RichText } from '@/app/lib/RichText';
import { dashify, sliceStyle } from '@/app/lib/utils';
import { RevealTitle } from '@/app/lib/RevealTitle';
import { BackgroundImage } from "@/app/lib/ParallaxBackground";
import IconChevron from '@/app/assets/images/icon_chevron.svg';
import styles from './collapsiblePanel.module.scss';
import sharedStyles from '@/app/shared.module.scss';

const CollapsiblePanel = ({ slice }) => {
  const [openIndexes, setOpenIndexes] = useState([]);
  const hasTitle = Boolean(slice?.primary?.title?.trim());
  const hasContent = Boolean(asText(slice?.primary?.content)?.trim());
  const hasTop = hasTitle || hasContent;

  const togglePanel = (index) => {
    setOpenIndexes((prevOpenIndexes) => {
      if (prevOpenIndexes.includes(index)) {
        return prevOpenIndexes.filter((i) => i !== index);
      } else {
        return [...prevOpenIndexes, index];
      }
    });
  };

  const renderPanel = (item, index) => {
    if (item?.title && isFilled.richText(item?.content)) {
      const isOpen = openIndexes.includes(index);
      return (
        <div
          className={clsx(styles.panel, { [styles.opened]: isOpen })}
          key={index}
        >
          <div className={clsx(styles.header)} onClick={() => togglePanel(index)}
            style={{ backgroundColor: item?.background_color ? item?.background_color : '', color: item?.text_color ? item?.text_color : '' }}
            >
            <h2>{item?.title}</h2>
            <IconChevron className={clsx(styles.chevron, { [styles.rotated]: isOpen })} />
          </div>

          <div className={clsx(styles.body, item?.limit_width && styles.limitWidth)}>
            <div className={clsx(styles.inner)}>
              <RichText field={item.content} />
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <BackgroundImage slicePrimary={slice?.primary}>
      <div className={clsx(styles.wrapper, styles[slice?.primary?.number_of_columns], hasTop ? styles.withTop : styles.withoutTop)} style={sliceStyle(slice?.primary)}>

        {hasTop && (
          <div className={clsx(sharedStyles.top)}>
            <div className={clsx(sharedStyles.left)}>
              { hasTitle && (
                <h1 className={clsx(sharedStyles.h1)} id={dashify(slice?.primary?.title)}>
                  <RevealTitle size='small'>{slice?.primary?.title}</RevealTitle>
                </h1>
              )}
              
              { hasContent && (
                <div className={clsx(sharedStyles.copy, styles.copy)}>
                  <RichText field={slice?.primary?.content}/>
                </div>
              )}
            </div>
          </div>
        )}

        <div className={clsx(styles.main)}>
          <div className={clsx(styles.panels)}>
            {slice?.primary?.panels.slice(0, Math.ceil(slice?.primary?.panels.length / 2)).map((item, index) => (
              renderPanel(item, index)
            ))}
          </div>

          <div className={clsx(styles.panels)}>
            {slice?.primary?.panels.slice(Math.ceil(slice?.primary?.panels.length / 2)).map((item, index) => (
              renderPanel(item, Math.ceil(slice?.primary?.panels.length / 2) + index)
            ))}
          </div>
        </div>

      </div>
    </BackgroundImage>
  )
};

export default CollapsiblePanel;